import { render, staticRenderFns } from "./SingleDetailsModal.vue?vue&type=template&id=284f8dc9&"
import script from "./SingleDetailsModal.vue?vue&type=script&lang=js&"
export * from "./SingleDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./SingleDetailsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports